var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":"Add New Examinee"},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"ok":_vm.handleOk},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return cancel()}}},[_vm._v("Cancel")]),_c('b-button',{staticClass:"bg-site-primary",attrs:{"size":"sm","disabled":!_vm.isFormValid ? "disabled" : null,"variant":"primary"},on:{"click":function($event){return ok()}}},[_vm._v("Generate Examinee Accounts")])]}}])},[_c('b-table',{staticClass:"align-middle",attrs:{"stacked":"","borderless":true,"fields":[
        {
          key: 'creditGroup',
          label: 'Credit Group'
        },
        {
          key: 'credits',
          label: 'Total Credits'
        },
        {
          key: 'nonActiveExamineeCount',
          label: 'Non-Active Examinees',
        },
        {
          key: 'availableCredits',
          label: 'Available Credits'
        },
        {
          label: 'Options'
        },
        {
          key: 'newExaminees',
          label: 'New Examinees'
        },
        {
          key: 'expiryDate',
          label: 'Examinee Expiry'
        } ],"items":[{
      credits: _vm.credits,
      nonActiveExamineeCount: _vm.nonActiveExamineeCount,
      availableCredits: _vm.availableCredits
    }]},scopedSlots:_vm._u([{key:"cell(creditGroup)",fn:function(){return [_c('b-form-select',{attrs:{"options":_vm.creditGroupOptions,"placeholder":"Select a Credit Group..."},model:{value:(_vm.selectedCreditGroup),callback:function ($$v) {_vm.selectedCreditGroup=$$v},expression:"selectedCreditGroup"}})]},proxy:true},{key:"cell(options)",fn:function(){return [_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})]},proxy:true},{key:"cell(newExaminees)",fn:function(){return [_c('b-form-input',{on:{"keypress":function($event){return _vm.filterNumberOnlyWithMax($event)}},model:{value:(_vm.newExaminees),callback:function ($$v) {_vm.newExaminees=$$v},expression:"newExaminees"}})]},proxy:true},{key:"cell(expiryDate)",fn:function(){return [_c('b-form-datepicker',{model:{value:(_vm.expiryDate),callback:function ($$v) {_vm.expiryDate=$$v},expression:"expiryDate"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }